import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router's client-side navigation doesn't reset scroll position the
// way a real page load does — so clicking any link (footer, header, in
// content) while scrolled down lands you on the new page still scrolled
// down, often looking like nothing happened or landing mid-content on
// something confusing. This resets scroll to top on every route change,
// site-wide, in one place instead of needing a useEffect on every page.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Also re-apply a frame later: if the new page's content is still
    // laying out (images, late-loading sections) right as this runs, an
    // immediate reset can get overridden by the browser's own scroll
    // anchoring compensating for that layout shift.
    const raf = requestAnimationFrame(() => window.scrollTo(0, 0));
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
}
